// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.catalog-manager {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}
.catalog-manager ion-split-pane {
  flex: 1;
  display: flex;
  background: transparent;
  width: 100%;
}
.catalog-manager ion-split-pane .pane {
  flex: 1;
  width: 50%;
  max-width: 100% !important;
  display: flex;
  flex-direction: column;
  border: 3px solid transparent;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: rgba(255, 255, 255, 0.95);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  border-radius: 20px;
  margin: 10px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  overflow: scroll;
}
.catalog-manager ion-split-pane .pane.active {
  border-color: #667eea;
  background: rgb(255, 255, 255);
  box-shadow: 0 15px 50px rgba(102, 126, 234, 0.3);
  transform: scale(1.01);
}
.catalog-manager ion-split-pane .pane .pane-header {
  direction: rtl;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}
.catalog-manager ion-split-pane .pane .pane-header h3 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.catalog-manager ion-split-pane .pane .pane-header .toolbar {
  display: flex;
  gap: 0.75rem;
}
.catalog-manager ion-split-pane .pane .pane-header .toolbar ion-button {
  --background: rgba(255, 255, 255, 0.2);
  --background-hover: rgba(255, 255, 255, 0.3);
  --background-activated: rgba(255, 255, 255, 0.4);
  --color: white;
  --border-radius: 12px;
  --padding-start: 1rem;
  --padding-end: 1rem;
  --box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0.3px;
}
.catalog-manager ion-split-pane .pane .breadcrumbs {
  direction: rtl;
  position: sticky;
  top: 0;
  z-index: 100;
  padding: 1rem 2rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  font-size: 0.95rem;
  color: white;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.catalog-manager ion-split-pane .pane .breadcrumbs .breadcrumb-trail {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.3rem;
}
.catalog-manager ion-split-pane .pane .breadcrumbs .breadcrumb-trail .breadcrumb-arrow {
  color: rgba(255, 255, 255, 0.6);
  font-size: 1.2rem;
  margin: 0 0.25rem;
  -webkit-user-select: none;
          user-select: none;
}
.catalog-manager ion-split-pane .pane .breadcrumbs .breadcrumb-trail .breadcrumb-item {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  transition: all 0.2s;
  color: white;
}
.catalog-manager ion-split-pane .pane .breadcrumbs .breadcrumb-trail .breadcrumb-item:hover:not(.last) {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}
.catalog-manager ion-split-pane .pane .breadcrumbs .breadcrumb-trail .breadcrumb-item.last {
  font-weight: 700;
  color: white;
  cursor: default;
  background: rgba(255, 255, 255, 0.15);
}
.catalog-manager ion-split-pane .pane .content-vertical {
  flex: 1;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
}
.catalog-manager ion-split-pane .pane .content-vertical .section-tree {
  flex-shrink: 0;
  border-bottom: 2px solid rgba(102, 126, 234, 0.1);
  background: linear-gradient(to bottom, rgba(102, 126, 234, 0.02), transparent);
}
.catalog-manager ion-split-pane .pane .content-vertical .item-list {
  flex: 1;
  min-height: 0;
  overflow: visible;
}
.catalog-manager ion-split-pane .pane .content-vertical::-webkit-scrollbar {
  width: 8px;
}
.catalog-manager ion-split-pane .pane .content-vertical::-webkit-scrollbar-track {
  background: rgba(102, 126, 234, 0.05);
}
.catalog-manager ion-split-pane .pane .content-vertical::-webkit-scrollbar-thumb {
  background: rgba(102, 126, 234, 0.3);
  border-radius: 4px;
}
.catalog-manager ion-split-pane .pane .content-vertical::-webkit-scrollbar-thumb:hover {
  background: rgba(102, 126, 234, 0.5);
}
.catalog-manager ion-split-pane .pane .stats {
  padding: 1rem 2rem;
  border-top: 2px solid rgba(102, 126, 234, 0.1);
  background: linear-gradient(to top, rgba(102, 126, 234, 0.05), transparent);
  font-size: 0.95rem;
  color: #667eea;
  font-weight: 500;
}
.catalog-manager .action-toolbar {
  display: flex;
  gap: 1rem;
  padding: 1.5rem 2rem;
  background: rgba(255, 255, 255, 0.95);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  justify-content: center;
  flex-wrap: wrap;
  box-shadow: 0 -10px 40px rgba(0, 0, 0, 0.1);
  margin: 0 10px 10px;
  border-radius: 20px;
}
.catalog-manager .action-toolbar ion-button {
  --background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  --background-hover: linear-gradient(135deg, #5568d3 0%, #653a8b 100%);
  --background-activated: linear-gradient(135deg, #4452bc 0%, #542e73 100%);
  --color: white;
  --border-radius: 12px;
  --padding-start: 1.5rem;
  --padding-end: 1.5rem;
  --box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.5px;
  transition: transform 0.2s, box-shadow 0.2s;
}
.catalog-manager .action-toolbar ion-button:hover {
  transform: translateY(-2px);
  --box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}
.catalog-manager .action-toolbar ion-button:active {
  transform: translateY(0);
}

@media (max-width: 768px) {
  .catalog-manager ion-split-pane {
    flex-direction: column;
  }
  .catalog-manager ion-split-pane .pane {
    min-height: 45vh;
    margin: 5px;
  }
  .catalog-manager ion-split-pane .pane .pane-header {
    padding: 1rem 1.5rem;
  }
  .catalog-manager ion-split-pane .pane .pane-header h3 {
    font-size: 1.2rem;
  }
  .catalog-manager ion-split-pane .pane .content-vertical .section-tree {
    max-height: 150px;
  }
  .catalog-manager .action-toolbar {
    padding: 1rem;
    gap: 0.75rem;
  }
  .catalog-manager .action-toolbar ion-button {
    --padding-start: 1rem;
    --padding-end: 1rem;
    font-size: 0.9rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shaps/pages/catalog-admin/catalog-manager/catalog-manager.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;EAEA,6DAAA;EACA,uGAAA;AAAF;AAEE;EACE,OAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;AAAJ;AAEI;EACE,OAAA;EACA,UAAA;EACA,0BAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,iDAAA;EACA,qCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,mBAAA;EACA,YAAA;EACA,2CAAA;EACA,gBAAA;AAAN;AAEM;EACE,qBAAA;EACA,8BAAA;EACA,gDAAA;EACA,sBAAA;AAAR;AAGM;EACE,cAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,oBAAA;EACA,6DAAA;EACA,YAAA;AADR;AAGQ;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,yCAAA;AADV;AAIQ;EACE,aAAA;EACA,YAAA;AAFV;AAIU;EACE,sCAAA;EACA,4CAAA;EACA,gDAAA;EACA,cAAA;EACA,qBAAA;EACA,qBAAA;EACA,mBAAA;EACA,4CAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;AAFZ;AAOM;EACE,cAAA;EACA,gBAAA;EACA,MAAA;EACA,YAAA;EACA,kBAAA;EACA,6DAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,yCAAA;AALR;AAOQ;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AALV;AAOU;EACE,+BAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;UAAA,iBAAA;AALZ;AAQU;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,oBAAA;EACA,YAAA;AANZ;AAQY;EACE,oCAAA;EACA,YAAA;AANd;AASY;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,qCAAA;AAPd;AAaM;EACE,OAAA;EAEA,sBAAA;EAEA,gBAAA;EACA,kBAAA;AAbR;AAgBQ;EACE,cAAA;EACA,iDAAA;EACA,8EAAA;AAdV;AAiBQ;EACE,OAAA;EACA,aAAA;EACA,iBAAA;AAfV;AAkBQ;EACE,UAAA;AAhBV;AAmBQ;EACE,qCAAA;AAjBV;AAoBQ;EACE,oCAAA;EACA,kBAAA;AAlBV;AAoBU;EACE,oCAAA;AAlBZ;AAuBM;EACE,kBAAA;EACA,8CAAA;EACA,2EAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AArBR;AA0BE;EACE,aAAA;EACA,SAAA;EACA,oBAAA;EACA,qCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,uBAAA;EACA,eAAA;EACA,2CAAA;EACA,mBAAA;EACA,mBAAA;AAxBJ;AA0BI;EACE,+DAAA;EACA,qEAAA;EACA,yEAAA;EACA,cAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,iDAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,2CAAA;AAxBN;AA0BM;EACE,2BAAA;EACA,iDAAA;AAxBR;AA2BM;EACE,wBAAA;AAzBR;;AAgCA;EAEI;IACE,sBAAA;EA9BJ;EAgCI;IACE,gBAAA;IACA,WAAA;EA9BN;EAgCM;IACE,oBAAA;EA9BR;EAgCQ;IACE,iBAAA;EA9BV;EAmCQ;IACE,iBAAA;EAjCV;EAuCE;IACE,aAAA;IACA,YAAA;EArCJ;EAuCI;IACE,qBAAA;IACA,mBAAA;IACA,iBAAA;EArCN;AACF","sourcesContent":[".catalog-manager {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  width: 100%;\n  //direction: ltr;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n\n  ion-split-pane {\n    flex: 1;\n    display: flex;\n    background: transparent;\n    width: 100%;\n    \n    .pane {\n      flex: 1;\n      width: 50%;\n      max-width: 100% !important;\n      display: flex;\n      flex-direction: column;\n      border: 3px solid transparent;\n      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n      background: rgba(255, 255, 255, 0.95);\n      backdrop-filter: blur(10px);\n      border-radius: 20px;\n      margin: 10px;\n      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);\n      overflow: scroll;\n      \n      &.active {\n        border-color: #667eea;\n        background: rgba(255, 255, 255, 1);\n        box-shadow: 0 15px 50px rgba(102, 126, 234, 0.3);\n        transform: scale(1.01);\n      }\n\n      .pane-header {\n        direction: rtl;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 1.5rem 2rem;\n        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n        color: white;\n        \n        h3 {\n          margin: 0;\n          font-size: 1.5rem;\n          font-weight: 600;\n          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n        }\n\n        .toolbar {\n          display: flex;\n          gap: 0.75rem;\n\n          ion-button {\n            --background: rgba(255, 255, 255, 0.2);\n            --background-hover: rgba(255, 255, 255, 0.3);\n            --background-activated: rgba(255, 255, 255, 0.4);\n            --color: white;\n            --border-radius: 12px;\n            --padding-start: 1rem;\n            --padding-end: 1rem;\n            --box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n            font-weight: 500;\n            text-transform: none;\n            letter-spacing: 0.3px;\n          }\n        }\n      }\n\n      .breadcrumbs {\n        direction: rtl;\n        position: sticky;\n        top: 0;\n        z-index: 100;\n        padding: 1rem 2rem;\n        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n        font-size: 0.95rem;\n        color: white;\n        font-weight: 500;\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n        \n        .breadcrumb-trail {\n          display: flex;\n          align-items: center;\n          flex-wrap: wrap;\n          gap: 0.3rem;\n          \n          .breadcrumb-arrow {\n            color: rgba(255, 255, 255, 0.6);\n            font-size: 1.2rem;\n            margin: 0 0.25rem;\n            user-select: none;\n          }\n          \n          .breadcrumb-item {\n            display: inline-flex;\n            align-items: center;\n            cursor: pointer;\n            padding: 0.25rem 0.5rem;\n            border-radius: 4px;\n            transition: all 0.2s;\n            color: white;\n            \n            &:hover:not(.last) {\n              background: rgba(255, 255, 255, 0.2);\n              color: white;\n            }\n            \n            &.last {\n              font-weight: 700;\n              color: white;\n              cursor: default;\n              background: rgba(255, 255, 255, 0.15);\n            }\n          }\n        }\n      }\n\n      .content-vertical {\n        flex: 1;\n        //display: flex;\n        flex-direction: column;\n\n        overflow-y: auto;\n        overflow-x: hidden;\n\n\n        .section-tree {\n          flex-shrink: 0;\n          border-bottom: 2px solid rgba(102, 126, 234, 0.1);\n          background: linear-gradient(to bottom, rgba(102, 126, 234, 0.02), transparent);\n        }\n\n        .item-list {\n          flex: 1;\n          min-height: 0;\n          overflow: visible;\n        }\n        \n        &::-webkit-scrollbar {\n          width: 8px;\n        }\n        \n        &::-webkit-scrollbar-track {\n          background: rgba(102, 126, 234, 0.05);\n        }\n        \n        &::-webkit-scrollbar-thumb {\n          background: rgba(102, 126, 234, 0.3);\n          border-radius: 4px;\n          \n          &:hover {\n            background: rgba(102, 126, 234, 0.5);\n          }\n        }\n      }\n\n      .stats {\n        padding: 1rem 2rem;\n        border-top: 2px solid rgba(102, 126, 234, 0.1);\n        background: linear-gradient(to top, rgba(102, 126, 234, 0.05), transparent);\n        font-size: 0.95rem;\n        color: #667eea;\n        font-weight: 500;\n      }\n    }\n  }\n\n  .action-toolbar {\n    display: flex;\n    gap: 1rem;\n    padding: 1.5rem 2rem;\n    background: rgba(255, 255, 255, 0.95);\n    backdrop-filter: blur(10px);\n    justify-content: center;\n    flex-wrap: wrap;\n    box-shadow: 0 -10px 40px rgba(0, 0, 0, 0.1);\n    margin: 0 10px 10px;\n    border-radius: 20px;\n\n    ion-button {\n      --background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n      --background-hover: linear-gradient(135deg, #5568d3 0%, #653a8b 100%);\n      --background-activated: linear-gradient(135deg, #4452bc 0%, #542e73 100%);\n      --color: white;\n      --border-radius: 12px;\n      --padding-start: 1.5rem;\n      --padding-end: 1.5rem;\n      --box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n      font-weight: 600;\n      text-transform: none;\n      letter-spacing: 0.5px;\n      transition: transform 0.2s, box-shadow 0.2s;\n\n      &:hover {\n        transform: translateY(-2px);\n        --box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n      }\n\n      &:active {\n        transform: translateY(0);\n      }\n    }\n  }\n}\n\n// Mobile responsive\n@media (max-width: 768px) {\n  .catalog-manager {\n    ion-split-pane {\n      flex-direction: column;\n\n      .pane {\n        min-height: 45vh;\n        margin: 5px;\n\n        .pane-header {\n          padding: 1rem 1.5rem;\n\n          h3 {\n            font-size: 1.2rem;\n          }\n        }\n\n        .content-vertical {\n          .section-tree {\n            max-height: 150px;\n          }\n        }\n      }\n    }\n\n    .action-toolbar {\n      padding: 1rem;\n      gap: 0.75rem;\n\n      ion-button {\n        --padding-start: 1rem;\n        --padding-end: 1rem;\n        font-size: 0.9rem;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
